"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SwitchToggle;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _utils = require("@whitbread-eos/utils");
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function SwitchToggle(_ref) {
  var {
    onToggle,
    first,
    second,
    defaultSelected = true,
    baseDataTestId
  } = _ref;
  var [firstSelected, setFirstSelected] = (0, _react.useState)(defaultSelected);
  var handleToggle = () => {
    setFirstSelected(prev => !prev);
    onToggle(!firstSelected);
  };
  var handleKeyUp = event => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleToggle();
    }
  };
  return (0, _jsxRuntime.jsxs)("div", {
    role: "switch",
    "aria-checked": firstSelected,
    onClick: handleToggle,
    onKeyUp: handleKeyUp,
    style: styles.switchToggle,
    "data-testid": (0, _utils.formatDataTestId)(baseDataTestId, 'SwitchToggle'),
    children: [(0, _jsxRuntime.jsx)("span", {
      "data-testid": (0, _utils.formatDataTestId)(baseDataTestId, 'first'),
      style: _objectSpread(_objectSpread({}, styles.option), firstSelected ? styles.selected : {}),
      children: first
    }), (0, _jsxRuntime.jsx)("span", {
      "data-testid": (0, _utils.formatDataTestId)(baseDataTestId, 'second'),
      style: _objectSpread(_objectSpread({}, styles.option), !firstSelected ? styles.selected : {}),
      children: second
    })]
  });
}
var styles = {
  switchToggle: {
    height: '2.625rem',
    border: '1px solid #cccccc',
    borderRadius: '2.625rem',
    display: 'inline-flex',
    justifyContent: 'space-between',
    padding: '0.188rem',
    cursor: 'pointer',
    userSelect: 'none'
  },
  option: {
    lineHeight: '2.1rem',
    display: 'inline-block',
    textAlign: 'center',
    flexGrow: 1,
    padding: '0 0.875rem'
  },
  selected: {
    backgroundColor: '#00798e',
    borderRadius: '2rem',
    color: '#ffffff'
  }
};